// Campus photo for /colleges/creighton-university: CC BY-SA 2.0, by Tony Webster from Minneapolis, Minnesota, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACreighton_University%2C_Omaha%2C_Nebraska_(31424784467).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/creighton-university/; credited under the photo.
const photo = {
    "slug": "creighton-university",
    "alt": "The Creighton University campus in Omaha, Nebraska",
    "src": "/colleges/creighton-university/campus-1600.webp",
    "srcSmall": "/colleges/creighton-university/campus-800.webp",
    "srcMid": "/colleges/creighton-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/creighton-university/og.jpg",
    "title": "Creighton University, Omaha, Nebraska (31424784467)",
    "author": "Tony Webster from Minneapolis, Minnesota, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACreighton_University%2C_Omaha%2C_Nebraska_(31424784467).jpg",
    "read": "2026-10-02"
};

export default photo;
